import axios from 'axios';
import { API_PATH } from '../../../constants';
import createMetadataAPIActions from '../../utils/api-metadata-actions';

const options = {
  name: 'authorization',
  baseType: 'AUTHORIZATION',
  apiEndpoint: 'authorization'
};

const actions = createMetadataAPIActions(options);

// Make the API call to get the permissions. This is unique because it uses a
// POST call to get data, so we cannot use the standard fetch operation
const fetchPermissions = queries => dispatch => {
  dispatch(actions.startFetch);

  return axios
    .post(`${API_PATH}/${options.apiEndpoint}`, queries)
    .then(response => dispatch(actions.fetchSuccessful(response.data)))
    .catch(error => dispatch(actions.fetchFailed(error)));
};

export default {
  fetchPermissions
};
